// Only this font family is used throughout the app.
const fontFamily = "'Outfit', sans-serif";

const fontFamilyMono = "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace";

// Raw size scale (px).
const fontSize = {
    xxs: 9,
    xs: 10,
    sm: 11,
    base: 12,
    md: 13,
    lg: 14,
    xl: 16,
    '2xl': 18,
    '3xl': 20,
    '4xl': 22,
    '5xl': 24,
    '6xl': 26,
    '7xl': 30,
};

const fontWeight = {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
};

// Spacing scale (px) — for padding / margin / gap / radius, so those
// values are tokenised too instead of hardcoded.
const spacing = {
    xs: 2,
    sm: 4,
    md: 6,
    lg: 8,
    xl: 10,
    '2xl': 14,
    '3xl': 16,
    '4xl': 32,
};

// Each preset is a FUNCTION returning a style object ready to spread into
// an inline `style={...}`. Pass overrides to tweak size/weight/colour:
//   <h2 style={heading2()}>…</h2>
//   <p style={body({ color: '#fff' })}>…</p>
const preset = (size, weight) => (overrides = {}) => ({
    fontFamily,
    fontSize: size,
    fontWeight: weight,
    ...overrides,
});

// Page / section headings
const heading1 = preset(fontSize['7xl'], fontWeight.bold);     // 30 / 700
const heading2 = preset(fontSize['5xl'], fontWeight.bold);     // 24 / 700
const heading3 = preset(fontSize['3xl'], fontWeight.semibold); // 20 / 600

// Sub-headings
const subHeading1 = preset(fontSize['2xl'], fontWeight.semibold); // 18 / 600
const subHeading2 = preset(fontSize.xl, fontWeight.semibold);     // 16 / 600
const subHeading3 = preset(fontSize.lg, fontWeight.medium);       // 14 / 500

// Body copy
const body = preset(fontSize.md, fontWeight.regular);      // 13 / 400
const bodySmall = preset(fontSize.base, fontWeight.regular); // 12 / 400

// Supporting text
const label = preset(fontSize.sm, fontWeight.medium);   // 11 / 500
const caption = preset(fontSize.xs, fontWeight.regular); // 10 / 400

const fonts = {
    fontFamily,
    fontFamilyMono,
    fontSize,
    fontWeight,
    spacing,
    heading1,
    heading2,
    heading3,
    subHeading1,
    subHeading2,
    subHeading3,
    body,
    bodySmall,
    label,
    caption,
};

export {
    fontFamily,
    fontFamilyMono,
    fontSize,
    fontWeight,
    spacing,
    heading1,
    heading2,
    heading3,
    subHeading1,
    subHeading2,
    subHeading3,
    body,
    bodySmall,
    label,
    caption,
};
export default fonts;
